import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.editStudent.addConfirmation.title',
    defaultMessage: 'STUDENT ADDED',
  },
  subtitle: {
    id: 'classesStudents.editStudent.addConfirmation.subtitle',
    defaultMessage: 'Student was added successfully',
  },
  continue: {
    id: 'classesStudents.editStudent.addConfirmation.continue',
    defaultMessage: 'Continue',
  },
});
